import { Coordinate } from "ol/coordinate"
import { ActionResponse } from "../../../components/AddItemForm/types"
import { createArea, createFleetArea, updateArea } from "../../../services/calls/area"
import i18n from "../../../i18n"
import { DTO_FleetArea } from "../../../services/calls/types/area"
import { InputError } from "../../../components/Input/types"

type Area = {
  name: string
  description?: string
  enabled: boolean
  radius?: number
  shapetype?: 'Circle' | 'Polygon'
  centerLon?: number
  centerLat?: number
  polyshape?: Coordinate[]
  fleets?: number[]
}

export const saveArea = async (data: Area, id?: number): Promise<ActionResponse> => {
  // Validate data
  let isValid = true
  const error: Record<string, InputError> = {}

  if (!data.name || !data.name.length) {
    error.name = {
      type: 'error',
      message: i18n.t('Name is required')
    }
  }

  if (isValid) {
    let resp
    if (id) {
      resp = await updateArea(data, id)
    } else {
      resp = await createArea(data)
      data.fleets?.forEach((fleet) => {
        const fleedData: DTO_FleetArea = {
          fleetid: Number(fleet),
          homebase: false,
          areaid: resp?.areaid
        }
        createFleetArea(fleedData)
      })
    }

    return {
      status: 'success',
      data: resp
    }
  }

  return {
    status: 'error',
    data: error
  }
}
